import React from "react";

const PILLARS = [
  { tag: "01", title: "Established 1993 — UAE interior fit-out" },
  { tag: "02", title: "Complete turnkey execution — design to handover" },
  { tag: "03", title: "In-house joinery, upholstery & curtains" },
  { tag: "04", title: "2,300+ projects delivered" },
  { tag: "05", title: "Trusted across the UAE" },
];

export default function TrustSection({
  testid = "trust-section",
  eyebrow = "Why Clients Choose Time Furniture",
  heading,
  subtone = false,
}) {
  return (
    <section
      data-testid={testid}
      className={`${
        subtone ? "bg-[#F2E9D8]" : "bg-[#FAF5EC]"
      } border-y border-[#6E1F2C]/15`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32 lg:py-36">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 mb-16 md:mb-20">
          <div className="lg:col-span-5">
            <p className="eyebrow mb-5">{eyebrow}</p>
            {heading && (
              <h2 className="font-serif-display text-3xl md:text-5xl lg:text-[56px] tracking-tight leading-[1.05] text-[#1C110C]">
                {heading}
              </h2>
            )}
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="text-[#3E2A22] leading-[1.85] text-base md:text-[17px]">
              Three decades of craftsmanship. A single accountable partner from
              concept through handover — design, civil works, MEP, joinery,
              upholstery, curtains and finishing under one roof.
            </p>
          </div>
        </div>

        <div className="border-t border-[#6E1F2C]/20">
          {PILLARS.map((p, i) => (
            <div
              key={p.tag}
              data-testid={`${testid}-pillar-${i}`}
              className="grid grid-cols-12 gap-6 md:gap-12 py-8 md:py-10 border-b border-[#6E1F2C]/15"
            >
              <p className="col-span-2 md:col-span-1 font-serif-display text-xl md:text-2xl text-[#D4A963]">
                {p.tag}
              </p>
              <p className="col-span-10 md:col-span-11 font-serif-display text-xl md:text-3xl lg:text-[34px] leading-[1.2] tracking-tight text-[#1C110C]">
                {p.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
